var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconCongrats = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.4074,
    fill: "#A6F282",
    stroke: "white",
    strokeWidth: 1.18519
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.553 13.4087L20.9118 12.5592C21.0396 12.2582 21.0355 11.9324 20.9201 11.6478C20.8087 11.3633 20.5901 11.1282 20.285 10.9962C19.6787 10.7405 18.9777 11.0251 18.722 11.6313L19.3653 10.1096C19.4932 9.80853 19.489 9.48274 19.3736 9.20231C19.2622 8.91776 19.0395 8.6827 18.7385 8.55485C18.1323 8.29505 17.4312 8.57547 17.1755 9.18169L17.6044 8.17133C17.7322 7.87028 17.7281 7.54449 17.6127 7.25994C17.5013 6.97538 17.2827 6.74032 16.9776 6.60835C16.3713 6.35267 15.6703 6.63722 15.4146 7.23932L14.7713 8.75693C14.8991 8.45588 14.8909 8.13421 14.7795 7.84554C14.6682 7.56511 14.4413 7.32592 14.1403 7.19808C13.5382 6.94239 12.8371 7.22282 12.5814 7.82492L9.58747 14.8769L8.80805 12.9551C8.56061 12.3448 7.86779 12.0478 7.25745 12.2953C6.79556 12.485 6.51514 12.9304 6.51514 13.4005C6.51514 13.549 6.544 13.7015 6.60174 13.8459C6.60174 13.8459 7.86366 16.9306 8.26781 17.9657C8.61835 18.8688 9.22456 19.8833 10.503 20.7452",
    stroke: "#315122",
    strokeWidth: 1.18519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2476 12.7529L18.7218 11.6271",
    stroke: "#315122",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9463 12.0766L17.1752 9.18164",
    stroke: "#315122",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0908 10.361L14.7754 8.75269",
    stroke: "#315122",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8252 20.209L24.3345 19.5409C24.6315 19.409 24.8542 19.1698 24.9614 18.8811C25.0727 18.5966 25.0727 18.2708 24.9408 17.9738C24.6768 17.3717 23.9716 17.0996 23.3737 17.3635L24.3758 16.9181C24.6727 16.7861 24.8954 16.547 25.0067 16.2583C25.1181 15.9737 25.1222 15.6521 24.9861 15.351C24.7222 14.7489 24.0129 14.4767 23.4149 14.7407L21.9097 15.4046C22.2066 15.2727 22.4252 15.0335 22.5365 14.7448C22.6478 14.4602 22.6478 14.1344 22.5159 13.8375C22.2519 13.2354 21.5426 12.9632 20.9488 13.2272L13.9422 16.3243L14.6886 14.3901C14.9278 13.7757 14.6227 13.087 14.0082 12.8519C13.3937 12.6127 12.705 12.9179 12.47 13.5323C12.47 13.5323 11.2823 16.6459 10.8658 17.6769C10.3874 18.8605 10.1028 20.4894 11.1173 22.7782C12.1318 25.0711 15.2577 26.1516 17.794 25.0299L23.7943 22.3782C24.0912 22.2462 24.3139 22.0071 24.4253 21.7184C24.5366 21.4338 24.5407 21.1122 24.4046 20.8111C24.1407 20.209 23.4314 19.9368 22.8334 20.2008L22.8252 20.209Z",
    stroke: "#315122",
    strokeWidth: 1.18519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7114 21.5865L22.825 20.2091",
    stroke: "#315122",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.751 19.409L23.3739 17.3635",
    stroke: "#315122",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7856 17.2316L21.9096 15.4088",
    stroke: "#315122",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4854 10.8518H23.8193",
    stroke: "#315122",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.211 7.78357L23.0356 8.95889",
    stroke: "#315122",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1426 8.17538V6.51343",
    stroke: "#315122",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCongrats, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconCongrats.035f6aa2.svg";
export { ForwardRef as ReactComponent };